import { Phone, MessageSquare, MapPin, Clock, Instagram } from "lucide-react";
import { BUSINESS } from "@/lib/config";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.36a8.16 8.16 0 0 0 4.77 1.52V6.43a4.85 4.85 0 0 1-1.84.36z" />
  </svg>
);
const FacebookIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" {...props}>
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12z" />
  </svg>
);

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative border-t border-zinc-900 bg-black pb-24 lg:pb-0"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src={BUSINESS.logo} alt="OTGG" className="logo-blend h-14 w-14 object-contain" />
            <div>
              <div className="font-heading text-xl text-white">On The Go <span className="text-otgg-red">Gloss</span></div>
              <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase">Mobile Detailing</div>
            </div>
          </div>
          <p className="text-zinc-400 text-sm max-w-md leading-relaxed mb-5">
            Premium mobile detailing brought to your driveway, office, or job site. Showroom shine — wherever you park.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={BUSINESS.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="w-10 h-10 rounded-full border border-zinc-800 bg-zinc-950 grid place-items-center text-zinc-300 hover:text-white hover:border-white/40 transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href={BUSINESS.facebookUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="w-10 h-10 rounded-full border border-zinc-800 bg-zinc-950 grid place-items-center text-zinc-300 hover:text-white hover:border-white/40 transition-colors"
            >
              <FacebookIcon width={16} height={16} />
            </a>
            <a
              href={BUSINESS.tiktokUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-tiktok"
              aria-label="TikTok"
              className="w-10 h-10 rounded-full border border-zinc-800 bg-zinc-950 grid place-items-center text-zinc-300 hover:text-white hover:border-white/40 transition-colors"
            >
              <TikTokIcon width={16} height={16} />
            </a>
            <span className="text-zinc-500 text-xs">@{BUSINESS.instagram}</span>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="flex items-center gap-2 text-zinc-300 hover:text-white">
                <Phone size={14} /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS.smsHref} data-testid="footer-sms" className="flex items-center gap-2 text-zinc-300 hover:text-white">
                <MessageSquare size={14} /> Text us anytime
              </a>
            </li>
            <li>
              <a href={BUSINESS.googleReviewUrl} target="_blank" rel="noreferrer" data-testid="footer-google" className="flex items-center gap-2 text-zinc-300 hover:text-white">
                <MapPin size={14} /> Find us on Google
              </a>
            </li>
            <li>
              <a href="/fleet" data-testid="footer-fleet" className="flex items-center gap-2 text-zinc-300 hover:text-white">
                <MapPin size={14} /> Fleet & contracts
              </a>
            </li>
            <li className="flex items-center gap-2 text-zinc-400">
              <MapPin size={14} /> {BUSINESS.serviceArea}
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Hours</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li className="flex items-center gap-2"><Clock size={14} /> Mon – Sat · 8am – 7pm</li>
            <li className="flex items-center gap-2"><Clock size={14} /> Sun · By appointment</li>
          </ul>
          <div className="mt-6 text-xs uppercase tracking-[0.2em] text-zinc-600">Home · Work · Anywhere</div>
        </div>
      </div>
      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-zinc-600 gap-2">
          <div>© {new Date().getFullYear()} On The Go Gloss Mobile Detailing. All rights reserved.</div>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-zinc-400">Admin</a>
        </div>
      </div>
    </footer>
  );
}
